import React from 'react';
import PropTypes from 'prop-types';
import Address from './Address';
import RouteLink from '../components/RouteLink';
import Text from '../containers/Text';
import IconButton from './IconButton';
import DetailLinkContainer from '../containers/DetailLinkContainer';
import CallbackButtonContainer from '../containers/CallbackButtonContainer';
import { formatDate, showHolidays } from '../utilities/showHolidays';
import {TranslatedLink} from '../containers/Text';
import isTimingOkay from '../utilities/isTimingOkay';

export const ShopListItem = ({
  shop, onClick, onMouseOver, onMouseOut, isHighlighted, isSelected, onMapClick,
  showRouteLink, showMapLink, showDetailLink
}) => {
    const address = {
        street: shop.street,
        houseNumber: shop.houseNumber,
        zip: shop.zip,
        city: shop.city
      };

  const currentUserTime = `${new Date().getHours()}.${new Date().getMinutes()}`

  let isOpenToday = (shop) => {
    const days = {
      1: 'MON',
      2: 'TUE',
      3: 'WED',
      4: 'THU',
      5: 'FRI',
      6: 'SAT',
      7: 'SUN'
    };
    const todayIndex = new Date().getDay() === 0 ? 7 : new Date().getDay(); // convert 0-> because getDay() has index 0 for SUN, and API has index 7 for SUN

    // With comma => working hours with lunch break in between
    if (!!shop.openToday && shop.openToday.includes(',')) {
      const openTodayArray1 = shop.openToday.split(',').map((element) => {
        return element.replace(/:/g, '.');
      });

      const openTodayArray2 = openTodayArray1.map((element) => {
        return element.split('-');
      });

      const openTodayArray3 = openTodayArray2.map((element) => {
        if (
          parseFloat(currentUserTime, 10) >= parseFloat(element[0], 10) &&
          parseFloat(currentUserTime, 10) <= parseFloat(element[1], 10)
        ) {
          return true;
        }
        return false;
      });

      //if time is after lunch break, show only until when it's still open: "Geöffnet bis 18:00 Uhr"
      if (
        parseFloat(openTodayArray2[1][0], 10) <
          parseFloat(currentUserTime, 10) &&
        parseFloat(currentUserTime, 10) < parseFloat(openTodayArray2[1][1], 10)
      ) {
        return (
          <div className="open-today">
            <Text id="time-filter.opened" className="t-md-b sushi-green" />
            <span className="t-md-b sushi-green">
              {openTodayArray2[1][1].replace(/\./g, ':')}
            </span>
            <Text id="time-filter.clock" className="t-md-b sushi-green" />
          </div>
        );
      }

      // if opened right now
      // Grade offen und noch mehrere Öffnungszeiten an diesem Tag: "Geöffnet bis 12:00 Uhr und ab 14:00 Uhr" (in grün, weil offen)
      if (openTodayArray3[0] || openTodayArray3[1]) {
        return (
          <div className="open-today">
            <Text id="time-filter.opened" className="t-md-b sushi-green" />
            <span className="t-md-b sushi-green">
              {openTodayArray2[0][1].replace(/\./g, ':')}
            </span>
            <Text id="time-filter.from" className="t-md-b sushi-green" />
            <span className="t-md-b sushi-green">
              {openTodayArray2[1][0].replace(/\./g, ':')}
            </span>
            <Text id="time-filter.clock" className="t-md-b sushi-green" />
          </div>
        );
      }

      // if today is not opened anymore, show first open hour tomorrow
      // Hat heute nicht oder nicht mehr auf: "Öffnet am Montag um 08:00 Uhr" (nächster Tag mit Öffnungszeiten)
      if (
        parseFloat(currentUserTime, 10) >
          parseFloat(openTodayArray2[1][1], 10) &&
        (!shop.holidays || shop.holidays.length === 0)
      ) {
        let nextDay = null;
        let nextDayOpenFrom = null;

        shop.hours.forEach(function (element, index) {
          if (element.weekday === todayIndex) {
            // if today is open
            //open next week, first day
            nextDay = days[shop.hours[0].weekday];
            nextDayOpenFrom = shop.hours[0].openFrom;

            //open next day
            if (shop.hours[index + 1]) {
              nextDay = days[shop.hours[index + 1].weekday];
              nextDayOpenFrom = shop.hours[index + 1].openFrom;
            }
          }
        });

        return (
          <div className="open-today">
            <Text
              id="time-filter.openedNextDay"
              className="t-md-b text-danger"
            />
            <span className="t-md-b text-danger">
              <Text id={`days.full.${nextDay}`} />
            </span>
            &nbsp;
            <Text id="time-filter.at" className="t-md-b text-danger" />
            &nbsp;
            <span className="t-md-b text-danger">{nextDayOpenFrom}</span>
            <Text id="time-filter.clock" className="t-md-b text-danger" />
          </div>
        );
      }

      // if closed right now, show when it opens first today (not after lunch break)
      if (parseFloat(currentUserTime, 10) < parseFloat(openTodayArray2[0][0])) {
        return (
          <div className="open-today">
            <Text id="time-filter.closed" className="t-md-b text-danger" />
            <span className="t-md-b text-danger">
              {openTodayArray2[0][0].replace(/\./g, ':')}
            </span>
            <Text id="time-filter.clock" className="t-md-b text-danger" />
          </div>
        );
      }

      //if current user time is between lunch time
      if (
        parseFloat(openTodayArray2[0][1]) < parseFloat(currentUserTime, 10) &&
        parseFloat(currentUserTime, 10) < parseFloat(openTodayArray2[1][0])
      ) {
        return (
          <div className="open-today">
            <Text id="time-filter.closed" className="t-md-b text-danger" />
            <span className="t-md-b text-danger">
              {openTodayArray2[1][0].replace(/\./g, ':')}
            </span>
            <Text id="time-filter.clock" className="t-md-b text-danger" />
          </div>
        );
      }
    }

    // without comma => working hours without lunch break in between
    else if (!!shop.openToday && !shop.openToday.includes(',')) {
      const openTodayUpdated = shop.openToday
        .split('-')
        .map((element) => element.replace(':', '.'));

      // if opened right now
      // Grade offen: "Geöffnet bis 18:00 Uhr" (in grün, weil offen)
      if (
        parseFloat(currentUserTime, 10) >=
          parseFloat(openTodayUpdated[0], 10) &&
        parseFloat(currentUserTime, 10) <= parseFloat(openTodayUpdated[1], 10)
      ) {
        return (
          <div className="open-today">
            <Text id="time-filter.opened" className="t-md-b sushi-green" />
            <span className="t-md-b sushi-green">
              {openTodayUpdated[1].replace(/\./g, ':')}
            </span>
            <Text id="time-filter.clock" className="t-md-b sushi-green" />
          </div>
        );
      }

      //if it's open right now and stays open till next day till 3am:  04:00 - 03:00
      if (
        parseFloat(currentUserTime, 10) > parseFloat(openTodayUpdated[1], 10) &&
        openTodayUpdated[1].charAt(0) === '0'
      ) {
        let nextDay = null;
        let nextDayOpenTill = null;

        shop.hours.forEach(function (element, index) {
          if (element.weekday === todayIndex) {
            // if today is open
            //open next week, first day
            nextDay = days[shop.hours[0].weekday];
            nextDayOpenTill = shop.hours[0].openTil;

            //open next day
            if (shop.hours[index + 1]) {
              nextDay = days[shop.hours[index + 1].weekday];
              nextDayOpenTill = shop.hours[index + 1].openTil;
            }
          }
        });

        return (
          <div className="open-today">
            <Text id="time-filter.opened" className="t-md-b sushi-green" />
            <span className="t-md-b sushi-green">{nextDayOpenTill}</span>
            <Text id="time-filter.clock" className="t-md-b sushi-green" />
          </div>
        );
      }

      // if today is not opened anymore, show first open hour tomorrow
      // Öffnet am Montag um 08:00 Uhr" (nächster Tag mit Öffnungszeiten)
      if (
        parseFloat(currentUserTime, 10) > parseFloat(openTodayUpdated[1], 10) &&
        (!shop.holidays || shop.holidays.length === 0)
      ) {
        let nextDay = null;
        let nextDayOpenFrom = null;

        shop.hours.forEach(function (element, index) {
          if (element.weekday === todayIndex) {
            // if today is open
            //open next week, first day
            nextDay = days[shop.hours[0].weekday];
            nextDayOpenFrom = shop.hours[0].openFrom;
            //open next day
            if (shop.hours[index + 1]) {
              nextDay = days[shop.hours[index + 1].weekday];
              nextDayOpenFrom = shop.hours[index + 1].openFrom;
            }
          }
        });

        return (
          <div className="open-today">
            <Text
              id="time-filter.openedNextDay"
              className="t-md-b text-danger"
            />
            <span className="t-md-b text-danger">
              <Text id={`days.full.${nextDay}`} />
            </span>
            &nbsp;
            <Text id="time-filter.at" className="t-md-b text-danger" />
            &nbsp;
            <span className="t-md-b text-danger">{nextDayOpenFrom}</span>
            <Text id="time-filter.clock" className="t-md-b text-danger" />
          </div>
        );
      }

      // if closed right now, show when it opens today
      return (
        <div className="open-today">
          <Text id="time-filter.closed" className="t-md-b text-danger" />
          <span className="t-md-b text-danger">
            {openTodayUpdated[0].replace(/\./g, ':')}
          </span>
          <Text id="time-filter.clock" className="t-md-b text-danger" />
        </div>
      );
    }
    // if closed all day today, show thew next opened day
    // Öffnet am Montag um 08:00 Uhr" (nächster Tag mit Öffnungszeiten)
    else if (
      !!!shop.openToday &&
      (!shop.holidays || shop.holidays.length === 0)
    ) {
      let nextDay = null;
      let nextDayOpenFrom = null;

      nextDay = days[shop.hours[0].weekday];
      nextDayOpenFrom = shop.hours[0].openFrom;
      const hours = shop.hours;

      for (const [index, element] of hours.entries()) {
        if (element.weekday > todayIndex) {
          //open next day
          nextDay = days[shop.hours[index].weekday];
          nextDayOpenFrom = shop.hours[index].openFrom;
          break;
        }
      }

      return (
        <div className="open-today">
          <Text id="time-filter.openedNextDay" className="t-md-b text-danger" />
          <span className="t-md-b text-danger">
            <Text id={`days.full.${nextDay}`} />
          </span>
          &nbsp;
          <Text id="time-filter.at" className="t-md-b text-danger" />
          &nbsp;
          <span className="t-md-b text-danger">{nextDayOpenFrom}</span>
          <Text id="time-filter.clock" className="t-md-b text-danger" />
        </div>
      );
    }
  };

  let classNames = ['shop-list-item p-md'];

  if (isHighlighted) {
    classNames.push('shop-list-item--highlighted');
  }

  if (isSelected) {
    classNames.push('shop-list-item--selected');
  }

  const distanceInKm = shop.distance;

  let renderHolidayInfo = (shop) => {
    if (!shop.holidays || shop.holidays.length === 0) {
      return null;
    } else {
      if (shop.onHoliday || showHolidays(shop.holidays[0])) {
        return (
          <p className="t-md-b text-danger">
            <Text
              id="details.on-holiday.short"
              placeholders={{
                from: formatDate(shop.holidays[0].from),
                to: formatDate(shop.holidays[0].till)
              }}
            />
          </p>
        );
      } else {
        return null;
      }
    }
  };

  return (
    <div
      tabIndex={0}
      onClick={(event) => {
        // prevent open Infowindow when detail link is clicked
        if (event.target.parentElement.tagName.toLowerCase() === 'button') {
          return;
        }
        onClick(shop.parcelShopNumber);
        shop.isPaketParcelLock
          ? window.wts.push([
              'send',
              'click',
              { linkId: 'Liste.Sendungsverfolgung' }
            ]) /* nur bei Parcellock, sonst ist link nicht sichtbar */
          : window.wts.push([
              'send',
              'click',
              { linkId: 'Liste.PaketShop Vorschau' }
            ]); /* bei Klick auf Ergebnis */
      }}
    >
      {isTimingOkay(shop) ? (
        <li
          key={shop.parcelShopNumber}
          onMouseOver={() => {
            onMouseOver(shop.parcelShopNumber);
          }}
          onMouseOut={() => {
            onMouseOut(shop.parcelShopNumber);
          }}
          className={`${classNames.join(' ')}`}
        >
          <h2 className={`t-h3${shop.isPaketFuxx ? ' paketfuxx' : ''}`}>
            {shop.description || shop.name}
          </h2>

          <Address className="t-md" {...address} />

          {isOpenToday(shop)}

          {renderHolidayInfo(shop)}

          <div className="shop-list-item__distance">
            {distanceInKm.toFixed(2)} km
          </div>

          {shop.isPaketParcelLock ? (
            <div className="paketParcelLock-link-wrapper">
              <Text id="search.paketParcelLock.note" />
              <TranslatedLink
                href="search.paketParcelLock.link-url"
                text="search.paketParcelLock.link-text"
                className="paketParcelLock-link"
                webtrekk={true}
                target="_blank"
              />
            </div>
          ) : null}
          <CallbackButtonContainer shop={shop} />

          {showMapLink ? (
            <IconButton
              icon="map-marker"
              text="map"
              onClick={() => onMapClick(shop.parcelShopNumber)}
            />
          ) : null}
          {showDetailLink ? (
            <DetailLinkContainer
              parcelShopNumber={shop.parcelShopNumber}
              isPaketParcelLock={shop.isPaketParcelLock}
              isDetailLinkOnList={true}
              isDetailLinkOnMap={false}
              shop={shop}
            />
          ) : null}
          {showRouteLink ? (
            <RouteLink
              isDetailLinkOnList={true}
              isDetailLinkOnMap={false}
              end={address}
            />
          ) : null}
        </li>
      ) : null}
    </div>
  );
}

ShopListItem.propTypes = {
  shop: PropTypes.shape({
    parcelShopNumber: PropTypes.string.isRequired,
    description: PropTypes.string
  }).isRequired,

  onClick: PropTypes.func.isRequired,
  onMouseOut: PropTypes.func.isRequired,
  onMouseOver: PropTypes.func.isRequired
};

export default ShopListItem;
